import React, { Component } from 'react';

import {Link}from 'react-router-dom';

// images

import InfoJumb1 from './images/infoJumbo1.png';
import InfoJumb2 from './images/infoJumbo2.png';
import InfoJumb3 from './images/infoJumbo3.png';

import banner1 from './images/banner1.jpg';

import { Grid, Row, Col, Carousel, Breadcrumb, Button} from 'react-bootstrap';

class Loewer extends Component {
  render() {
    return (
      <div className='container-fluid'>
        <div className="supMainLS">
          <div className="BC">
          <Breadcrumb className='breadcrumb-item'>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item >
              <Link to="/Suppliers">Lieferanten</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
                <Link to="/Suppliers/SuB">SuB</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item active>Loewer</Breadcrumb.Item>
          </Breadcrumb>
          </div>
          <img src={banner1} alt="Loewer Headquater"/>
        </div>
        <div className="supMainTextLS">
          <h1>Loewer</h1>
          <Grid className="supMainInfo">
          <Row>
            <Col xsHidden smHidden md={5}>
              <Carousel  controls={false} interval={3000}>
                <Carousel.Item >
                    <img  src={InfoJumb1}  alt=""  height="100%" />
                </Carousel.Item>
                <Carousel.Item>
                    <img  src={InfoJumb2} alt=""  height="100%"/>
                </Carousel.Item>
                <Carousel.Item>
                    <img  src={InfoJumb3} alt=""  height="100%" />
                </Carousel.Item>
              </Carousel>
              </Col>
            <Col xsHidden md={7}>
              <h4>LOEWER entwickelt, fertigt und vertreibt Band- und Bürstschleifmaschinen für die Metall- und Holzbearbeitung. Als inhabergeführtes Familienunternehmen in sechster Generation ist LOEWER seit Jahrzehnten auf Schleiftechnik spezialisiert. Mit einer hohen Fertigungstiefe und qualifizierten Mitarbeitern werden sowohl bewährte Standardmaschinen als auch angepasste Sonderlösungen gefertigt. Die jahrzehntelange Spezialisierung auf Schleiftechnik führt zu einem immensen Know-How  in diesem Bereich. Über 20.000 LOEWER Maschinen wurden weltweit verkauft. LOEWER kennt die Anforderungen der Kunden genauso gut wie die schleiftechnischen Möglichkeiten. Viele Sondermaschinen zum Lösen spezieller Schleifaufgaben wurden gebaut, etliche Schleifwerkzeuge wurden entwickelt und getestet.
            </h4>
            </Col>
            <Col xs={12}  smHidden mdHidden lgHidden>
              <h4>LOEWER entwickelt, fertigt und vertreibt Band- und Bürstschleifmaschinen für die Metall- und Holzbearbeitung. Als inhabergeführtes Familienunternehmen in sechster Generation ist LOEWER seit Jahrzehnten auf Schleiftechnik spezialisiert.
            </h4>
            </Col>
            <Col xs={12} md={{ span: 7, offset: 2 }}>
              <Button className="supMainButtonWebPage" variant="light" href="http://www.loewer-online.com" target="_blank">Hersteller Homepage</Button>
            </Col>
          </Row>
        </Grid>
      </div>
        <br/>
        <section>
        <div className="supMainKeyWords">
          <br/>
          <Grid>
            <Row>
              <Col xsHidden  sm={4} md={2}>

                <h5>Langjährige Erfahrung</h5>
              </Col>
              <Col xsHidden  sm={4} md={2}>

                  <h5>Eigene Entwicklung und Fertigung</h5>
              </Col>
              <Col xsHidden  sm={4} md={2}>

                    <h5>Made in Germany</h5>
              </Col>
              <Col xsHidden  sm={4} md={2}>

                    <h5>Durchdachte Maschinenkonzeptionen</h5>
              </Col>
              <Col xsHidden  sm={4} md={2}>

                    <h5>Service aus erster Hand</h5>
              </Col>
              <Col xsHidden  sm={4} md={2}>

                    <h5>Standard- und Sonderlösungen</h5>
              </Col>

            </Row>
            <br/>
            <Row className="show-grid">
              <Col xs={12}  smHidden mdHidden lgHidden>

                <h5>&#9658; &nbsp; Langjährige Erfahrung</h5>
              </Col>
              <Col xs={12}  smHidden mdHidden lgHidden>

                  <h5>&#9658; &nbsp; Eigene Entwicklung und Fertigung</h5>
              </Col>
              <Col xs={12}  smHidden mdHidden lgHidden>

                    <h5>&#9658; &nbsp; Made in Germany</h5>
              </Col>
              <Col xs={12}  smHidden mdHidden lgHidden>

                    <h5>&#9658; &nbsp; Durchdachte Maschinenkonzeptionen</h5>
              </Col>
              <Col xs={12}  smHidden mdHidden lgHidden>

                    <h5>&#9658; &nbsp; Service aus erster Hand</h5>
              </Col>
              <Col xs={12}  smHidden mdHidden lgHidden>

                    <h5>&#9658; &nbsp; Standard- und Sonderlösungen</h5>
              </Col>


            </Row>
          </Grid>
          <br/>
        </div>
        <br/>
      </section>
      <section>
        <Grid className="gridUp">
          <center>
            <h1>Produkte</h1>
          </center>
          <Row className="show-grid">
            <Col  xs={12} sm={12}>
              <center>
                <Link to="/Suppliers/Loewer/Produkte"><h4 className="buttonBlue">Produkte</h4></Link>
              </center>
              </Col>
            </Row>
          </Grid>
          <br/>
      </section>
        </div>
    );
  }
}

export default Loewer;



// WEBPACK FOOTER //
// ./src/components/pages/supplier/loewer/mainPageSup.js